export const EMERGENCY_LIGHTING_INSTRUCTIONS = [
  "Use a fish key to isolate mains power. Do not shut off the main lighting distribution board.",
  "Walk all escape routes and confirm every emergency light illuminates.",
  "Restore power and confirm charging indicators (green LEDs) are active.",
];

export function isEmergencyLightingPass(
  data: Record<string, unknown> | null | undefined,
): boolean {
  return data?.allLightsWorking === true;
}

export function canSubmitEmergencyLighting(params: {
  roomId: string;
  allLightsWorking: boolean | null;
}): boolean {
  return !!params.roomId && params.allLightsWorking !== null;
}
